import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { UINotice } from '../../../components/controls/ui/UINotice/UINotice';
import { Newrelic } from '../../../external-references';
import { useRedirectParam } from '../../../scripts/hooks';
import './AuthActionContainer.scss';
interface AuthActionContainerProps {
  title: string;
  secondaryAction?: ReactNode;
  warningMessage?: ReactNode;
  secondaryCentered?: boolean;
}

export const AuthActionContainer: FC<AuthActionContainerProps> = ({
  title,
  secondaryAction,
  children,
  secondaryCentered,
  warningMessage,
}) => {
  const [redirectParam] = useRedirectParam();
  return (
    <div
      className="authActionContainer"
      data-newrelic-id={Newrelic.AuthActionContainer}
    >
      {!!redirectParam && (
        <UINotice centered>You need to sign in to view this content</UINotice>
      )}
      <h1>{title}</h1>
      {warningMessage && (
        <h3 className="warningMessage">
          <strong>{warningMessage}</strong>
        </h3>
      )}
      {children}
      {secondaryAction && (
        <div
          className={classNames(
            {
              centered: secondaryCentered,
            },
            'secondaryAction'
          )}
        >
          {secondaryAction}
        </div>
      )}
    </div>
  );
};
